import { module } from 'stereomodularjs'

import Swiper from 'swiper';
import { Navigation, Pagination, A11y} from 'swiper/modules';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, A11y]);

export default class extends module {
    constructor(m) {
        super(m)
    }

    init() {
        this.params = {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1,
            grabCursor: true,
            spaceBetween: 20,
            touchEventsTarget: 'container',

            // If we need pagination
            pagination: {
                el: this.el.querySelector('.swiper-pagination'),
                clickable: true,
            },

            // a11y
            a11y: {
                // prevSlideMessage: 'Previous slide',
                // nextSlideMessage: 'Next slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
            },
        }

        this.typeSlider = this.el.dataset.type

        if (this.typeSlider == 'img') {
            this.params.navigation = {
                nextEl: this.el.querySelector('.swiper-button-next'),
                prevEl: this.el.querySelector('.swiper-button-prev'),
            }
            this.params.slidesPerView = 1.075
            this.params.centeredSlides = true
            this.params.centeredSlidesBounds = true
            this.params.loop = false
            this.params.speed = 750
            this.params.spaceBetween = 0
            this.params.breakpoints = {
                768: {
                    slidesPerView: 1.1,
                },
                1024: {
                    slidesPerView: 1.15,
                },
                1280: {
                    slidesPerView: 1.2,
                },
                1440: {
                    slidesPerView: 1.2125,
                },
                1600: {
                    slidesPerView: 1.35,
                },
                1920: {
                    slidesPerView: 1.4,
                },
            }
            setTimeout(() => {
                this.el.querySelector('.swiper-controls').style.width = this.el.querySelector('.swiper-slide > *').offsetWidth + 'px'
            }, 100)
            window.addEventListener('resize', () => {
                setTimeout(() => {
                    this.el.querySelector('.swiper-controls').style.width = this.el.querySelector('.swiper-slide > *').offsetWidth + 'px'
                }, 100)
            })
        }

        if (this.typeSlider == 'foldslider') {
            this.params.navigation = {
                nextEl: this.el.querySelector('.swiper-button-next'),
                prevEl: this.el.querySelector('.swiper-button-prev'),
            }
            this.params.slidesPerView = 1
            this.params.centeredSlides = true
            this.params.centeredSlidesBounds = true
            this.params.loop = false
            this.params.speed = 750
            this.params.spaceBetween = 0
            this.params.pagination = {
                el: this.el.querySelector('.swiper-pagination'),
                clickable: true,
            }
        }

        if (this.typeSlider == 'team') {
            this.params.navigation = {
                nextEl: this.el.querySelector('.swiper-button-next'),
                prevEl: this.el.querySelector('.swiper-button-prev'),
            }
            this.params.slidesPerView = 1.3
            this.params.centeredSlides = true
            this.params.centeredSlidesBounds = true
            this.params.loop = true
            this.params.speed = 750
            this.params.spaceBetween = 20
            this.params.pagination = false
            this.params.breakpoints = {
                768: {
                    slidesPerView: 1.1,
                },
                1024: {
                    slidesPerView: 1.5,
                },
                1280: {
                    slidesPerView: 1.7,
                },
                1440: {
                    slidesPerView: 2.3,
                },
                1600: {
                    slidesPerView: 2.5,
                },
                1920: {
                    slidesPerView: 2.5,
                },
            }
            setTimeout(() => {
                this.el.querySelector('.swiper-controls').style.width = this.el.querySelector('.swiper-slide > *').offsetWidth + 'px'
            }, 100)
            window.addEventListener('resize', () => {
                setTimeout(() => {
                    this.el.querySelector('.swiper-controls').style.width = this.el.querySelector('.swiper-slide > *').offsetWidth + 'px'
                }, 100)
            })
        }

        if (this.typeSlider == 'testimonials') {
            this.params.navigation = {
                nextEl: this.el.querySelector('.swiper-button-next'),
                prevEl: this.el.querySelector('.swiper-button-prev'),
            }
            this.params.slidesPerView = 1
            this.params.centeredSlides = true
            this.params.centeredSlidesBounds = true
            this.params.loop = true
            this.params.speed = 750
            this.params.spaceBetween = 20
            this.params.pagination = false
            
            setTimeout(() => {
                this.el.querySelector('.swiper-controls').style.width = this.el.querySelector('.swiper-slide > *').offsetWidth + 'px'
            }, 100)
            window.addEventListener('resize', () => {
                setTimeout(() => {
                    this.el.querySelector('.swiper-controls').style.width = this.el.querySelector('.swiper-slide > *').offsetWidth + 'px'
                }, 100)
            })
        }

        if (this.typeSlider == 'department') {
            this.params.navigation = {
                nextEl: this.el.nextElementSibling.querySelector('.js-slider-department-next'),
                prevEl: this.el.nextElementSibling.querySelector('.js-slider-department-prev'),
            }
            this.params.slidesPerView = 'auto'
            this.params.speed = 750
            this.params.pagination = false
            this.params.loop = true
            this.params.spaceBetween = 0
        }

        this.slider = new Swiper(this.el, this.params)

        
        if (this.typeSlider == 'foldslider') {
            this.slider.on('slideChange', () => {
                setTimeout(() => {
                    // Watch for changes, if slide contain not initialized modules, initialize them
                    let foldVideo = this.el.querySelector('.swiper-slide-active [data-module="FoldVideo"]');
                    if (foldVideo && foldVideo.innerHTML.trim() === '') {
                        this.call('init', 'FoldVideo');
                    }

                    // Play video in active slide and pause videos in inactive slides
                    let activeSlide = this.el.querySelector('.swiper-slide-active');
                    let videoEl = activeSlide.querySelector('video');
                    if (videoEl) {
                        videoEl.play();
                    }

                    // Pause videos in inactive slides
                    let inactiveSlides = this.el.querySelectorAll('.swiper-slide:not(.swiper-slide-active) video');
                    inactiveSlides.forEach((video) => {
                        video.pause();
                    });

                }, 1);
            });
        }
    }
}